import { Grid, Paper } from '@mui/material';
import InputConfig from '../../../../Components/InputConfig';
import { useContext } from 'react';
import { FvpConfigContext } from '../../../../Contexts/FvpConfigContext';
import useCommonStyles from '../../../../commonStyles';
import PageHeading from '../../../../Components/PageHeading';
import { ACCESS_CONTROL_CONSTANTS } from '../../../../core/constants';

const { SYSTEMS } = ACCESS_CONTROL_CONSTANTS;

/**
 * @name VideoSectionSettings
 * @description This component is an editor where we can change current selected videoSectionName
 */
const VideoSectionSettings = () => {
	const { rawConfig, updateRawConfig } = useContext(FvpConfigContext);
	const commonStyleClasses = useCommonStyles();
	return (
		<Paper className={commonStyleClasses.mainPagePaperMarginStyle}>
			<PageHeading
				headingName=" Video Section"
				headingPath={['Dashboard', 'Fvp', 'Video Section']}
				description="Manage video name configuration here."
			/>
			<Grid
				container
				spacing={1}
				style={{ height: '60%', width: '90%', marginLeft: '4rem', marginTop: '3rem' }}
			>
				<Grid item xs={4}>
					<InputConfig
						system={SYSTEMS.FVP_PLAYER}
						label="Video Section Id"
						keyData="videoSectionId"
						object={rawConfig}
						updateObject={updateRawConfig}
						editable={false}
					/>
				</Grid>
				<Grid item xs={4}>
					<InputConfig
						system={SYSTEMS.FVP_PLAYER}
						label="Video Section Name"
						keyData="videoSectionName"
						object={rawConfig}
						updateObject={updateRawConfig}
					/>
				</Grid>
			</Grid>
		</Paper>
	);
};

export default VideoSectionSettings;
